import React from 'react';
import styles from './FlatButtonAction.module.scss';
import Tooltip from '../Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';

export type FlatButtonActionProps = {
  label: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  testId?: string;
  tooltipWhenDisabled?: React.ReactNode;
  tooltipDescription?: string;
};

const FlatButtonAction: React.FC<FlatButtonActionProps> = ({
  label,
  onClick,
  disabled = false,
  className = '',
  testId,
  tooltipWhenDisabled,
  tooltipDescription,
}) => {
  const { t } = useTranslation();

  const content = tooltipWhenDisabled ?? (
    <span className={styles.tooltip_title}>
      {tooltipDescription ? t(`${tooltipDescription}`) : ''}
    </span>
  );

  const btn = (
    <span
      className={`${styles.flat_button_action} ${disabled ? styles.disabled : ''} ${className}`}
      role="button"
      aria-disabled={disabled}
      data-testid={testId}
      onClick={!disabled ? onClick : undefined}
    >
      {label}
    </span>
  );

  if (disabled) {
    return (
      <Tooltip
        content={content}
        width="180px"
        height="auto"
        bottom="33px"
        tipPos={true}
        className={styles.tooltip}
      >
        {btn}
      </Tooltip>
    );
  }

  return btn;
};

export default FlatButtonAction;
